
import { useMutation } from "@tanstack/react-query"

export const _FETCH = async ({route, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try{
        const response = await fetch(route, {
            headers: {'Authorization': `Bearer ${user.token}`},
          })
        
        const json = await response.json()
        
        // Check if the response was successful (status code 2xx)
        if (response.ok) {
            //process.env.NODE_ENV === "development" && console.log("_FETCH SUCCESS", json)
            onSuccess(json)
        } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_FETCH ERROR", json)
            onError(json, { route })
        }
        
        return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_FETCH ERROR", e)
        onError(e, { route })
        return ({error:e?.message})
    }
}

export const _FETCH_POST = async ({route, body, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try{
        const response = await fetch(route, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            },
            body: JSON.stringify(body)
        })
        
        const json = await response.json()
        
        // Check if the response was successful (status code 2xx)
        if (response.ok) {
            //process.env.NODE_ENV === "development" && console.log("_FETCH_POST SUCCESS", json)
            onSuccess(json)
        } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_FETCH_POST ERROR", json)
            onError(json, { route, body })
        }
        
        return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_FETCH_POST ERROR", e)
        onError(e, { route, body })
        return ({error:e?.message})
    }
}
export const _CREATE = async ({route, doc={}, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'POST',
            body: JSON.stringify(doc),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user.token}`
            }
          })
          const json = await response.json() 
          
          // Check if the response was successful (status code 2xx)
          if (response.ok) {
            onSuccess(json)
          } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_CREATE ERROR", json)
            onError(json, { route, doc })
          }
          
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_CREATE ERROR", e)
        onError(e, { route, doc })
        return ({error:e?.message})
    }   

}  
export const _CREATEPUBLIC = async ({route, doc={}, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'POST',
            body: JSON.stringify(doc),
            headers: {
              'Content-Type': 'application/json',
            }
          })
          const json = await response.json() 
          
          // Check if the response was successful (status code 2xx)
          if (response.ok) {
            onSuccess(json)
          } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_CREATEPUBLIC ERROR", json)
            onError(json, { route, doc })
          }
          
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_CREATEPUBLIC ERROR", e)
        onError(e, { route, doc })
        return ({error:e?.message})
    }   

}    


/* const _CREATEORREPLACE = (data) => {
    return SClient
     .createOrReplace(data.doc, {dryRun: false, autoGenerateArrayKeys: true}) 
 } */
 
/*  export const useUpdateDocument = ({...props}) => {
     return useMutation(_CREATEORREPLACE,{...props})
 } */
 
export const _UPDATE = async ({route, doc={}, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'PATCH',
            body: JSON.stringify(doc),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user.token}`
            }
          })
          const json = await response.json()
          
          // Check if the response was successful (status code 2xx)
          if (response.ok) {
            onSuccess(json)
          } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_UPDATE ERROR", json)
            onError(json, { route, doc })
          }
          
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_UPDATE ERROR", e)
        onError(e, { route, doc })
        return ({error:e?.message})
    }
}
export const _UPDATEPUBLIC = async ({route, doc={}, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'PATCH',
            body: JSON.stringify(doc),
            headers: {
              'Content-Type': 'application/json',
            }
          })
          const json = await response.json()
          
          // Check if the response was successful (status code 2xx)
          if (response.ok) {
            onSuccess(json)
          } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_UPDATEPUBLIC ERROR", json)
            onError(json, { route, doc })
          }
          
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_UPDATE ERROR", e)
        onError(e, { route, doc })
        return ({error:e?.message})
    }
}

export const _DELETE = async ({route, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${user.token}`
            }
          })
          const json = await response.json()
          
          // Check if the response was successful (status code 2xx)
          if (response.ok) {
            onSuccess(json)
          } else {
            // If response is not ok, call onError instead
            process.env.NODE_ENV === "development" && console.log("_DELETE ERROR", json)
            onError(json, { route })
          }
          
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_DELETE ERROR", e)
        onError(e, { route })
        return ({error:e?.message})
    }
}

export const _UPLOAD = async ({route, formData, user, onSuccess=()=>{}, onError=()=>{}}) => {
    try {
        const response = await fetch(route, {
            method: 'POST',
            body: formData,
            headers: {
              'Authorization': `Bearer ${user.token}`
            },
            credentials: 'include'
          })
          const json = await response.json()
          if (!response.ok) {
            throw new Error(json.error || 'Upload failed')
          }
          onSuccess(json)
          return json
    } catch(e) {
        process.env.NODE_ENV === "development" && console.log("_UPLOAD ERROR", e)
        onError(e, { route, formData })
        throw e
    }
}

export const useQueryDocuments = ({...props}) => {
    return useMutation(_FETCH,{...props})
}
